<template>
  <div>
    <el-container class="main-container">
      <el-header>
        <head_page :head_page_type=false ref="head_page"></head_page>
      </el-header>
      <el-main>
        <div id='choose_city'>
          <head_menu :has-back=true @go-back-click="goBack">
            <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{chosen_city_shown}}
              </div>
            </template>

            <template #button-group-right>
              <el-button-group>
                <el-button @click="dialogFormVisible = true" :disabled="ifSave">
                  {{ $t('message.Save_Data') }}
                </el-button>
                <el-dialog :visible.sync="dialogFormVisible">
                  <el-form :model="form" @submit.native.prevent>
                    <el-form-item :label="$t('message.Client_name')" :label-width="formLabelWidth">
                      <el-input v-model="form.name" @keyup.enter.native = "onSubmit"></el-input>
                    </el-form-item>
                  
                    <el-form-item :label="$t('message.Campaign_Starting_Date')">
                    <el-col :span="12" >
                      <el-date-picker type="date" placeholder="选择日期" v-model="campaignDate" style="width: 100%;"></el-date-picker>
                    </el-col>
                  </el-form-item>
                    <el-form-item :label="$t('message.Duration(Months)')">
                    <el-col :span="6" >
                      <p>{{duration}} </p>
                    </el-col>
                  </el-form-item>
                </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">{{$t('message.Cancel')}}</el-button>
                    <el-button type="primary" @click="onSubmit">{{$t('message.OK')}}</el-button>
                  </div>
                </el-dialog>
                <el-badge :value="dataValueBadge" class="item">
                  <el-button style="margin-left: 10px;" @click="goHistory" :disabled = "dataSaved">{{ $t('message.History') }}
                  </el-button>
                </el-badge>

              </el-button-group>
            </template>
          </head_menu>
          <!--
          <div style="text-align: left;">
            <el-row>
              <el-col :span="8" style="background-color: #F0F0EE;">
                <el-button-group>
                  <el-button icon="el-icon-d-arrow-left" @click="goBack" style="background-color: #f3f3f4;" :disabled = false></el-button>
                  <el-button icon="el-icon-s-home" @click="goHome" style="background-color: #e9e9ea;"></el-button>
                </el-button-group>
              </el-col>
              <el-col :span="6" style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{chosen_city_shown}}
              </el-col>
              <el-col :span="10" style="text-align: right;background-color: #F0F0EE;">
                <el-button-group>
                  <el-button @click="dialogFormVisible = true" :disabled="ifSave">
                    {{ $t('message.Save_Data') }}
                  </el-button>
                  <el-dialog :visible.sync="dialogFormVisible">
                    <el-form :model="form" @submit.native.prevent>
                      <el-form-item :label="$t('message.Client_name')" :label-width="formLabelWidth">
                        <el-input v-model="form.name" @keyup.enter.native = "onSubmit"></el-input>
                      </el-form-item>
                    
                      <el-form-item :label="$t('message.Campaign_Starting_Date')">
                      <el-col :span="12" >
                        <el-date-picker type="date" placeholder="选择日期" v-model="campaignDate" style="width: 100%;"></el-date-picker>
                      </el-col>
                    </el-form-item>
                      <el-form-item :label="$t('message.Duration(Months)')">
                      <el-col :span="6" >
                        <p>{{duration}} </p>
                      </el-col>
                    </el-form-item>
                  </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">{{$t('message.Cancel')}}</el-button>
                      <el-button type="primary" @click="onSubmit">{{$t('message.OK')}}</el-button>
                    </div>
                  </el-dialog>
                  <el-badge :value="dataValueBadge" class="item">
                    <el-button @click="goHistory" :disabled = "dataSaved">{{ $t('message.History') }}
                    </el-button>
                  </el-badge>

                </el-button-group>
              </el-col>
            </el-row>
          </div>
          -->
            <el-row style="margin-left: -10px; margin-right: -10px;">
              <el-col :span="8" class="info-list-style" style="height:264.444px;padding-left: 30px;" >

                <div style="text-align: left;margin-top: 10px" id ='selected_criterias'>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Gender')}}:</p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{gender}}</p>
                    </el-col>
                  </el-row>

                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Age')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{age}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Spend_Power')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{spend_power}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Interests')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{interest}}</p>
                    </el-col>

                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.POI')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{poi}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Media_Format')}}: </p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{media_type}}</p>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin:10px">
                    <el-col :span="7">
                      <p class="p9">{{$t('message.Nearby_Location')}}:</p>
                    </el-col>
                    <el-col :span="17">
                      <p class="p10">{{poi_ba_label_selection_list}}</p>
                    </el-col>
                  </el-row>
                </div>

              </el-col>
              
              
              <el-col :span="8" class="info-list-style" style="height:264.444px;
                            border-left:5px solid #EFEFEF;
                            border-right:5px solid #EFEFEF" >
                    <div style="background-color: white;margin:10px;height:40px;text-align:center">
                      <div style="padding: 5px;font-size: 18px;color:#254A6E;font-weight: 600;">
                        <span>{{$t('message.Campaign_Starting_Date')}} {{this.campaignDate_YYMMDD}}</span>
                      </div>
                    </div>

              <div id='KPI1'>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <p class="p7">{{$t('message.Number_of_Bus_Lines')}}</p>
                  </el-col>
                  <el-col :span="8">
                    <p class="p7">{{$t('message.Number_of_Bus_Body')}}</p>
                  </el-col>
                  <el-col :span="8">
                    <p class="p7">{{$t('message.Duration(Months)')}}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="div_number">
                      <p class="p8">{{bus_line_qty}}</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div>
                      <p class="p8">{{bus_body_qty}}</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div>
                      <p class="p8">{{duration}}</p>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="l1">
                    <p class="p7">{{$t('message.Viewed_Impression')}}
                    </p>
                  </el-col>
                  <el-col :span="l2" v-if="ifShowViewed">
                    <p class="p7">{{$t('message.Viewed_Impression(Audience)')}}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="l1">
                    <div class="div_number">
                      <p class="p8" style="font-size: 30px;">{{viewed_impression}}</p>
                    </div>
                  </el-col>
                  <el-col :span="l2">
                    <div>
                      <p class="p8" style="font-size: 30px;" v-if="ifShowViewed">{{viewed_impression_cluster}}</p>
                    </div>
                  </el-col>
                </el-row>
              </div>
              </el-col>
              <el-col :span="8" class="info-list-style" style="height:264.444px;padding-right: 30px;">
                </br>
                </br>
                <div id='KPI2'>
                <el-row>
                  <div style="height:30px;">
                    <p class="p7" style="font-size=20px">{{$t('message.Total_Package_Cost')}}</p>
                    <p class="p8" style="font-size: 30px;">￥{{package_price}}</p>
                  </div>
                  </br>
                  </br>
                  </br>
                </el-row>
                <el-row>
                  <el-col :span="l1">
                    <div>
                      <p class="p7">{{$t('message.Package_CPM')}}
                      </p>
                      <p class="p8" style="font-size: 30px;">￥{{package_cpm}}</p>
                    </div>
                  </el-col>
                  <el-col :span="l2" v-if="ifShowViewed">
                    <div>
                      <p class="p7">{{$t('message.Package_CPM_cluster')}}</p>
                      <p class="p8" style="font-size: 30px;">￥{{package_cpm_cluster}}</p>
                    </div>
                  </el-col>
                </el-row>
              </div>
              </el-col>
            </el-row>
            <br>
            <br>
            <br>
            <el-row :gutter="20">
              <el-col :span="24" style="margin-top: 10px;padding-left:30px;padding-right:30px">
                <div class="level2_div2" id="chart_impression">
                  <div>
                    <bar-chart :chart-data="datacollection_impression_total" :options="chart_options_impression_total"></bar-chart>
                  </div>
                </div>
                <div id="chart_cpm">
                  <!-- To be implemented-->
                </div>
              </el-col>
            </el-row>
          <div id='busTable'>
            <!-- <div class = "table-style">
            <el-row >
              <el-table :data="hideColumnTableDataCommercial" fit style="width: 100%;" :header-row-style="{color:'#254A6E','font-weight':'bold','font-size':'1.2em'}"
              :row-style="rowStyle">
                <el-table-column prop="bus_line_number" v-bind:label="$t('message.Bus_Lines')" align="center"> 
                </el-table-column>
                <el-table-column prop="duration" v-bind:label="$t('message.Duration2')" align="center">
                </el-table-column>
                <el-table-column prop="bus_quantity" v-bind:label="$t('message.Bus_Quantity')" align="center">
                </el-table-column>
                <el-table-column prop="price" v-bind:label="$t('message.Total_Media_Cost')" align="center" min-width="150">
                </el-table-column>
                <el-table-column prop="impression_total" v-bind:label="$t('message.Viewed_Impression()')" align="center" min-width="150">
                </el-table-column>
                <el-table-column prop="adjusted_impression" v-bind:label="$t('message.Viewed_Impression(Audience)')" align="center" min-width="200">
                </el-table-column>
                <el-table-column prop="CPM" v-bind:label="$t('message.CPM')" align="center">
                </el-table-column>
                <el-table-column prop="adjusted_CPM" v-bind:label="$t('message.CPM_Target_Audience_Based')" align="center" minn-width="150">
                </el-table-column>
              </el-table>
            </el-row>
            
            </div> -->
              <el-tabs v-model="activeTab">
                <el-tab-pane label="BAM表格" name="tab1">
    <!-- BAM表格内容 -->
              <el-row class = "table-style">
                <!-- <el-table :data="hideColumnTableDataCommercial" fit style="width: 100%" :summary-method="getSummaries"
                  show-summary> -->
                <el-table :data="selectedBusLine" fit style="width: 100%;"
                :row-class-name="tableRowClassName">
                  <el-table-column prop="bus_name" v-bind:label="$t('message.Bus_Line')">
                  </el-table-column>
                  <el-table-column prop="value_rating" v-bind:label="$t('message.index')">
                  </el-table-column>
                  <el-table-column prop="rank" v-bind:label="$t('message.Rank')">
                  </el-table-column>
                  <el-table-column v-if ="$i18n.locale=='en'" prop="media_type_label" v-bind:label="$t('message.Media_Format')" width="220">
                  </el-table-column>
                  <el-table-column v-if ="$i18n.locale=='cn'" prop="media_type_label" v-bind:label="$t('message.Media_Format')" width="220">
                  </el-table-column>
                  <el-table-column prop="bus_quantity" v-bind:label="$t('message.Bus_Quantity')" align="right">
                  </el-table-column>
                  <el-table-column prop="duration" v-bind:label="$t('message.Duration2')" align="right">
                  </el-table-column>
                  <el-table-column v-if="ifRankExists" prop="media_cost" v-bind:label="$t('message.Media_Cost')" align="right">
                  </el-table-column>
                  <el-table-column v-if="ifRankExists" prop="price" v-bind:label="$t('message.Total_Media_Cost')" align="right">
                  </el-table-column>
                  <el-table-column v-if="!ifRankExists" prop="impression_total" v-bind:label="$t('message.Viewed_Impression()')" align="right">
                  </el-table-column>
                  <el-table-column v-if ="ifShowViewed && !ifRankExists" prop="adjusted_impression" v-bind:label="$t('message.Viewed_Impression(Audience)')" align="right">
                  </el-table-column>
                  <el-table-column v-if="false" prop="CPM" v-bind:label="$t('message.CPM')" align="right">
                  </el-table-column>
                  <!-- <el-table-column v-if ="ifShowViewed && !ifRankExists" prop="adjusted_CPM" v-bind:label="$t('message.CPM_Target_Audience_Based')" align="right">
                  </el-table-column> -->
                </el-table>
              </el-row>
              </el-tab-pane>
              

              <el-tab-pane label="HUB模板" name="tab2">
    <div id="hub_template">
      <el-table :data="selectedBusLine" fit style="width: 100%;" :header-row-style="{color:'#254A6E','font-weight':'bold','font-size':'1.2em'}">
        <el-table-column prop="hub_city_code" label="城市Code"></el-table-column>
        <el-table-column prop="hub_city_name_cn" label="城市"></el-table-column>
        <el-table-column prop="hub_bus_id" label="巴士线路Code"></el-table-column>
        <el-table-column prop="bus_name" label="巴士线路"></el-table-column>
        <el-table-column prop="rank" label="线路级别"></el-table-column>
        <el-table-column prop="hub_media_format_code" label="发布形式细分Code" width="150"></el-table-column>
        <el-table-column v-if="$i18n.locale=='cn'" prop="media_type_label" label="发布形式细分" width="150"></el-table-column>
        <el-table-column prop="bus_quantity" label="巴士台数" align="right"></el-table-column>
      </el-table>
    </div>
  </el-tab-pane>
  </el-tabs>
          </div>
          <el-row :gutter="10" type="flex" justify="end" style="padding-right:25px;">
            <el-col :span="4">
              <el-input v-model="form.name" :placeholder="$t('message.Client_name')" :disabled = "ifSave">
              </el-input>
            </el-col>
            <el-upload action='localhost:8080/posts/' :on-change="handleUpload" :auto-upload="false" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG">
              <el-button slot="trigger">{{$t('message.Upload_logo')}}</el-button>
              <el-select v-model="exportType" :placeholder="$t('message.File_Type')">
                <el-option 
                v-for="item in exportTypeOptions" :key="item.value" :label="item.value" :value="item.value"> 
                </el-option>
              </el-select>
              <el-button @click="exportTypeSelector()">{{$t('message.Export')}}</el-button>
            </el-upload>
          </el-row>

          <el-row style="margin-top: 50px">
            <el-col :span="16" :offset="4">
              <div id='map'>
                <div>
                  <mapf id='inside_map' ref="mapf" style="margin-top: 20px;margin-bottom: 20px;" :mapId="'amap-container'" isBusMap=true></mapf>
                </div>
              </div>
            </el-col>
          </el-row>


        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import head_page from './components/head_page.vue';
  import head_menu from './components/head_menu.vue';
  import axios from 'axios';
  import _global from './components/global.vue';
  import BarChart from './components/BarChart.js';
  import DoughnutChart from './components/DoughnutChart.js';
  import chartjsPluginAnnotation from "chartjs-plugin-annotation";
  import exportPdf from "./components/exportPdf.js";
  import exportExcel from "./components/exportExcel.js";
  import mapf from './mapf.vue'

  var row_table = {
    "bus_id": 0,
    "media_type_label": "",
    "rate_card": 0,
    "production_cost": 0,
    "bus_quantity": 0,
    "duration": 0,
    "impression_total": 0,
    "price": 0,
    "CPM": 0,
    "reach": 0,
    "frequency": 0,
  };
  export default {
    name: 'package_board',
    data() {
      return {
        tableData: [{
          title: this.$t('message.Number_of_Bus_Lines'),
          value: ""
        }, {
          title: this.$t('message.Number_of_Bus_Body'),
          value: ""
        }, {
          title: this.$t('message.Duration'),
          value: ""
        }, {
          title: this.$t('message.Audience_Reach'),
          value: ""
        }, {
          title: this.$t('message.Viewed_Impression'),
          value: ""
        }, {
          title: this.$t('message.Viewed_Impression_Selection_Based'),
          value: ""
        }, {
          title: this.$t('message.Frequency'),
          value: ""
        }, ],
        estimated_cost: "",
        CPM: "",
        adjusted_CPM: "",
        bus_id_arr: Array(),
        impression_total_arr:Array(),
        impression_adjusted_arr:Array(),
        options: null,
        information: {
          value_duration:1,
          date:'T'
        },
        map: null,
        data: null,
        gender: null,
        age: null,
        spend_power: null,
        interest: null,
        poi: null,
        media_type: null,
        rank: null,
        lang: 'en',
        chosen_city: "",
        tableDataCommercial: [row_table, ],
        total_objects: null,
        datacollection_reach: {},
        datacollection_frequency: {},
        datacollection_impression_total: {},
        datacollection_price: {},
        datacollection_cpm: {},
        chart_options_impression_total: {},
        chart_options_price: {},
        chart_options_cpm: {},
        ifShowViewed: true,
        dialogFormVisible: false,
        form: {
          name: ''
        },
        formLabelWidth: '120px',
        clientLogoImage:'',
        campaignDate:null,
        campaignDate_YYMMDD:null,
        campaignDuration:'1',
        dataValueBadge:0,
        exportTypeOptions: [{value:'PDF'},{value:'Excel'},{value:'Hub Template'}],
        exportType:'',
        reference_id:'',
        createdBy:'',
        team:'',
        media_format_options : [],
        rank_options : [],
        dataHistory:'',
        flag: false,
        ifSave: false,
        impression_datasets:[],
        impression_annotations:[],
        cpm_datasets:[],
        cpm_annotations:[],
        responseSaveData:true,
        datacollection_gender:{},
        datacollection_age:{},
        datacollection_spend_power:{},
        datacollection_interest:{},
        datacollection_package_gender:{},
        datacollection_package_age:{},
        datacollection_package_spend_power:{},
        datacollection_package_interest:{},
        chart_options_gender: {},
        chart_options_age: {},
        chart_options_spend_power: {},
        chart_options_interest: {},
        chart_options_package_gender: {},
        chart_options_package_age: {},
        chart_options_package_spend_power: {},
        chart_options_package_interest: {},
        dataSaved: true,
        ifRank:false,
        poi_ba_label_selection_list:[],
        poi_ba_value_selection_list:[],
        package_id:'',
        package_info:{},
        bus_line_qty:null,
        bus_body_qty:null,
        duration:null,
        viewed_impression:null,
        viewed_impression_cluster:null,
        package_price:null,
        package_cpm:null,
        package_cpm_cluster:null,
        report_param:{},
        selectedBusLine:[],
        lastPage:null,
        related_poi_nb_summary:null,
        totalNearbyBusNumber:0,
        activeTab: 'tab1',
      }
    },
    beforeRouteEnter(to, from, next){
     next(vm => {
       // 通过 `vm` 访问组件实例,将值传入lastPage
       vm.lastPage = from.meta.title
      vm.ifSaveButtonActive(vm.lastPage)
     })
    },
    created() {
      document.title = 'Data Board';
    },
    mounted() {
      //this.chosen_city = this.$route.query.chosen_city
      this.storePackageIdToSessionStorage()
      this.getPackageData()
      this.$refs.head_page.update_user_name()
      this.lang = JSON.parse(sessionStorage.getItem('lang'))
      this.$i18n.locale = this.lang
      this.$refs.head_page.switchLang(this.lang)
      this.getReportLength()
      
      
      // let data = JSON.parse(sessionStorage.getItem('Data_History'))
      // if(data!=undefined){
      //   if(data.form!=undefined){
      //     this.form = data.form
      //   }
      // }
      // if (this.chosen_city != undefined){
      //   //正常流程
      //   this.fillData()
      //   this.fillData_Options()
      //   this.fillData_Info()
      //   this.fillData_map()
      //   this.fillTable()
      //   this.data = JSON.parse(sessionStorage.getItem('Data_Map'))
      //   this.ifShowViewed = JSON.parse(sessionStorage.getItem('ifShowViewed'))
       
      //   this.transDataOfTableData(this.tableData, this.data.tableData)
      //   this.estimated_cost = this.data.estimated_cost
      //   this.CPM = this.data.CPM
      //   this.adjusted_CPM = this.data.adjusted_CPM
      //   this.total_objects = sessionStorage.getItem('total_objects')
      // }else{
      //   //查看历史
      //   this.ifSave = true
      //   this.fromHistoryAction()
      // }
      // this.showBusLine()
    },
    computed:{
      l1: function(){
        return this.ifShowViewed?12:24
      },
      l2: function(){
        return this.ifShowViewed?12:0
      },
      chosen_city_shown: function() {
      
        let tmp = "message." + this.chosen_city
        return this.$t(tmp)
      },
      ifRankExists: function(){
        return !(this.rank=='' || this.rank==null)
      },
      hideColumnTableDataCommercial: function(){
         let a = this.tableDataCommercial
         let tmp = this.getSummaries()
         return tmp
      },
      localLang() {
        return this.$i18n.locale;
      }
    },
    methods: {
      ifSaveButtonActive(lastPage){
        //if from history page, save button disactive
        if (lastPage == 'history'){
          this.ifSave = true
        }
      },
      storePackageIdToSessionStorage(){
        // Change langue & refresh the page
        // Vuex's data will be initialed
        // Store data in sessionStorage 
        if(sessionStorage.getItem("selected_package_package_id")){
         this.$store.state.package.selected_package.selected_package_package_id = JSON.parse(sessionStorage.getItem("selected_package_package_id"))
        }
        window.addEventListener('beforeunload',()=>{
        sessionStorage.setItem('selected_package_package_id',JSON.stringify(this.$store.state.package.selected_package.selected_package_package_id))
        })
      },
      getPackageData(){
        let api_url = _global.serverSrc + '/selected_package_detail/' + '?format=json';
        let obj = new Object()
        obj.package_id = this.$store.state.package.selected_package.selected_package_package_id
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.package_detail) {
              this.package_info = response.data.package_detail[0]
              this.fillPackageData()
            }
          })
          .catch(function(error) {});
      },
      fillPackageData(){
        this.form.name = this.$store.state.package.selected_package.client_name
        this.ifSaveButtonActive()
        this.fillBoardData()
        this.impression_total_arr = []
        this.bus_id_arr = []
        this.impression_adjusted_arr = []
        this.fillTableData()
        this.fillChartDataAndOption()
        this.showBusLine()
      },
      fillBoardData(){
        this.chosen_city = this.package_info['city']
        this.bus_body_qty = this.package_info['bus_body_qty']
        this.bus_line_qty = this.package_info['bus_line_qty']
        this.duration = this.package_info['duration']
        this.viewed_impression = this.package_info['viewed_impression'].toLocaleString()
        this.viewed_impression_cluster = this.package_info['viewed_impression_cluster'].toLocaleString()
        this.package_price = this.package_info['package_price'].toLocaleString()
        this.package_cpm = this.package_info['package_cpm']
        this.package_cpm_cluster = this.package_info['package_cpm_cluster']
        this.report_param = JSON.parse(this.package_info['report_param'])
        this.selectedBusLine = this.report_param['package_selection']['selectedBusLine']
        this.campaignDate = this.report_param['Data_Information']['date']
        let campaignDate_temp = new Date(this.campaignDate)
        this.campaignDate_YYMMDD = campaignDate_temp.getFullYear()+'/'+(Number(campaignDate_temp.getMonth())+1).toString()+'/'+campaignDate_temp.getDate();
      

        this.tableData[0].value = this.bus_line_qty
        this.tableData[1].value = this.bus_body_qty
        this.tableData[4].value = this.viewed_impression
        this.tableData[5].value = this.viewed_impression_cluster

        let gender = this.report_param['Data_Information']['data_audience'].value_gender
        let age = this.report_param['Data_Information']['data_audience'].value_age
        let spend_power = this.report_param['Data_Information']['data_audience'].value_spend_power
        let interest = this.report_param['Data_Information']['data_audience'].value_interest
        let poi = this.report_param['Data_Information']['data_poi']
        let media_type = this.report_param['Data_Information']['data_media_rank']

        let gender_options = this.report_param['Data_Options']['audience_options']['gender_options']
        let age_options = this.report_param['Data_Options']['audience_options']['age_options']
        let spend_power_options = this.report_param['Data_Options']['audience_options']['spend_power_options']
        let interest_options = this.report_param['Data_Options']['audience_options']['interest_options']
        let poi_options = this.report_param['Data_Options']['poi_options']
        let media_type_options = this.report_param['Data_Options']['media_rank_options']['media_format_options']

        this.gender = this.changeDataToText(gender, gender_options)
        this.age = this.changeDataToText(age, age_options)
        this.spend_power = this.changeDataToText(spend_power, spend_power_options)
        this.interest = this.changeDataToText(interest, interest_options)
        this.poi = this.changeDataToText_poi(poi)
        this.media_type = this.changeDataToText(media_type,media_type_options)
        
        
        let poi_ba_label_selection_list = this.report_param['Data_Information']['poi_ba_label_selection_list']
        this.poi_ba_label_selection_list = this.changeDataToText_PoiSearch(poi_ba_label_selection_list)
        this.poi_ba_value_selection_list = this.report_param['Data_Information']['poi_ba_value_selection_list']
      },
      repeatRatio(bus_body){
      // Bus body repeat Ratio is x^0.75/x round to 3 demical
      return (Math.pow(bus_body,0.75)/bus_body).toFixed(3)
    },
      fillTableData(){
        this.selectedBusLine.forEach((item, index) => {
          //let total_impression = Math.round(item.IMP * this.repeatRatio(item.body_qty) * item.body_qty * this.duration)
          //let total_target_IMP = Math.round(item.target_IMP * this.repeatRatio(item.body_qty) * item.body_qty * this.duration)
          let total_impression = Math.round(item.IMP * this.repeatRatio(item.body_qty) * item.body_qty)
          let total_target_IMP = Math.round(item.target_IMP * this.repeatRatio(item.body_qty) * item.body_qty)

          this.impression_total_arr.push(Number(total_impression))
          this.impression_adjusted_arr.push(Number(total_target_IMP))

          this.selectedBusLine[index].bus_id = item.bus_id.replace('line_','line ')
          this.selectedBusLine[index].value_rating = Math.round(item.value_rating*100)
          this.selectedBusLine[index].rank_tag = item.rank_tag
          this.selectedBusLine[index].format_code = item.format_code[0]
          this.selectedBusLine[index].duration = this.duration
          this.selectedBusLine[index].IMP =  total_impression.toLocaleString()
          this.selectedBusLine[index].body_qty = item.body_qty
          this.selectedBusLine[index].target_IMP = total_target_IMP.toLocaleString()
            
          this.bus_id_arr.push(item.bus_name)

          // Fill name with missing value for PDF
          this.selectedBusLine[index].CPM = '套装CPM'
          this.selectedBusLine[index].adjusted_CPM = '套装CPM'
          this.selectedBusLine[index].rate_card = '套装价'
          this.selectedBusLine[index].price = '套装价'

          let format_code = this.selectedBusLine[index].format_code
          let format_code_options = this.report_param['Data_Options']['media_rank_options']['media_format_options']

          // Fill media format with label name
          for (let i in format_code_options){
            if (format_code_options[i]['value']==format_code){
              if (this.$i18n.locale == 'cn'){
            this.selectedBusLine[index].format_code = format_code_options[i]['label_cn']
          }else{
            this.selectedBusLine[index].format_code = format_code_options[i]['label']
          }

            }
          }
          // Rename to match old key name
          this.renameObjectKey(this.selectedBusLine[index],'rank_tag','rank')
          this.renameObjectKey(this.selectedBusLine[index],'format_code','media_type_label')
          this.renameObjectKey(this.selectedBusLine[index],'body_qty','bus_quantity')
          this.renameObjectKey(this.selectedBusLine[index],'IMP','impression_total')
          this.renameObjectKey(this.selectedBusLine[index],'target_IMP','adjusted_impression')

          // Sum up total nearby location number for one proposal
          // if(this.selectedBusLine[index].hasOwnProperty("related_poi_nb")){
          //   this.related_poi_nb_summary = this.related_poi_nb_summary + this.selectedBusLine[index].related_poi_nb
          // }
          if(this.selectedBusLine[index].hasOwnProperty("related_poi_nb")){
            if(this.selectedBusLine[index].related_poi_nb != 0){
              this.totalNearbyBusNumber += 1
            }
          }
        })

      },
      fillChartDataAndOption(){
        this.impression_datasets = [{
            label: this.$t('message.Viewed_Impression'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: this.impression_total_arr
          },
          {
            label: this.$t('message.Viewed_Impression(Audience)'),
            backgroundColor: '#80DEEA',
            borderColor: '#00ACC1',
            borderWidth: 1,
            hoverBackgroundColor: '#00ACC1',
            barPercentage: 0.8,
            data: this.impression_adjusted_arr
          }
          ]
        
        this.datacollection_impression_total = {
          labels: this.bus_id_arr,
          datasets: this.impression_datasets
        }
        this.chart_options_impression_total = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Viewed_Impression_chart'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          legend: {
            display: true,
          },
          gridLines: {
            offsetGridLines: false
          },
          scaleLabel:"<%=value%>",

          scales: {
            yAxes: [{
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                precision: 10,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          },
          annotation: {
            annotations: this.impression_annotations
          }
        }
      },

      renameObjectKey(obj,old_key_name,new_key_name){
        obj[new_key_name] = obj[old_key_name]
        delete obj[old_key_name]
        return obj
      },

      rowStyle({ row, rowIndex}) {
        return {'font-weight':'bold','font-size':'1.5em','height':'2em'}
      
    },

      tableRowClassName({row, rowIndex}) {
        return 'table-rows';
      },
      fromHistoryAction(){
        //说明数据是从history来的
        this.dataHistory = JSON.parse(sessionStorage.getItem('Data_History'))
        this.chosen_city = this.dataHistory.city
        sessionStorage.setItem('tableDataCommercial', JSON.stringify(this.dataHistory.bus_line))
        sessionStorage.setItem('Data_Options', JSON.stringify(this.dataHistory.options))
        this.fillTable()
        this.estimated_cost = this.dataHistory.estimated_cost.toLocaleString()
        this.CPM = this.dataHistory.CPM
        this.adjusted_CPM = this.dataHistory.adjusted_CPM
        this.ifShowViewed = this.changeBooleanInverse(this.dataHistory.ifShowViewed)
        this.form = this.dataHistory.form
        
        this.fillData_Options()
        let obj={}
        obj.data_audience=this.dataHistory.data_audience
        obj.data_poi = this.changeBooleanInverse(this.dataHistory.data_poi)
        let obj2={}
        obj2.value_media_format = this.dataHistory.data_media
        obj2.value_rank = this.dataHistory.data_rank
        obj.data_media_rank = obj2
        obj.campaignDate =this.dataHistory.date
        obj.campaignDuration = this.dataHistory.duration
        obj.poi_ba_label_selection_list = this.dataHistory.options.poi_ba_label_selection_list
        obj.poi_ba_value_selection_list = this.dataHistory.options.poi_ba_value_selection_list
        
        sessionStorage.setItem('Data_Information', JSON.stringify(obj))
        this.fillData_Info()
        this.tableData = this.dataHistory.tableData
        this.fillData()
      },
      onSubmit() {
        if (this.form.name == "" || this.form.name == null){
          this.openNotice3()
          this.dialogFormVisible = false
          return false
        }else{
          this.messageSaveData()
          this.dialogFormVisible = false
          return true
        }
      },
      openNotice3() {
        var _self = this;
        this.$notify({
          message: _self.$t('message.Please_enter_the_client_name'),
          position: 'top-left'
        });
      },
      getReportLength() {
        let api_url = _global.serverSrc + '/report_length/' + '?format=json';
        let obj = new Object()
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.report_length) {
              this.dataValueBadge = response.data.report_length[0].report_number
            }
          })
          .catch(function(error) {});
      },
      
      messageSaveData(){
        if (this.ifSave == true){
          //edit 状态不保存
          return
        }
        this.$confirm( this.$t('message.Do_you_want_to_save_data_you_made'), 'Info', {
          confirmButtonText: this.$t('message.OK'),
          cancelButtonText: this.$t('message.Cancel'),
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('message.Data_is_saved')
          });
          this.responseSaveData = true
          this.saveData()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('message.Cancelled')
          });
          this.responseSaveData = false
        });
      },
      saveData() {
        let obj = new Object()
        //let dataInformation = JSON.parse(sessionStorage.getItem('Data_Information'))
        //obj.data_audience = dataInformation.data_audience
        //obj.data_poi = this.changeBoolean(dataInformation.data_poi)
        //obj.data_media = dataInformation.data_media_rank.value_media_format
        //obj.data_rank = dataInformation.data_media_rank.value_rank 
        //obj.tableData = this.tableData
        obj.form = this.form
        obj.bus_line = this.selectedBusLine
        obj.estimated_cost= this.package_info['package_price']
        obj.package_id = this.$store.state.package.selected_package.selected_package_package_id
        //obj.CPM=this.CPM
        //obj.adjusted_CPM=this.adjusted_CPM
        let data = JSON.parse(sessionStorage.getItem('Data_Information'))
        // if (data.value_duration != null){
        //   obj.duration = data.value_duration
        // }else{
        //   obj.duration = data.campaignDuration
        // }
        obj.duration = this.duration
        // Convert from 13 timestamp to 10 timestamp
        // Fit for backend
        //obj.date = Math.round(this.campaignDate/1000)
        if (this.campaignDate != null){
          let tmp = this.campaignDate.split('T')[0].split('-')
          let date = Date.UTC(tmp[0],tmp[1]-1,tmp[2])
          obj.date = Math.round(date / 1000)
        }else{
          obj.date = data.campaignDate
        }
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        //obj.estimated_cost = this.delcommafy(this.estimated_cost)
        obj.viewed_impression = this.delcommafy(this.tableData[4].value)
        obj.city = this.chosen_city
        //obj.options={}
        //obj.options.audience_options = this.options.audience_options
        //obj.options.media_rank_options = this.options.media_rank_options
        // let dataMap =  JSON.parse(sessionStorage.getItem('Data_Map'))
        // if (dataMap !=null){
        //   obj.ifShowViewed = this.changeBoolean(dataMap.ifShowViewed)
        // }else{
        //   obj.ifShowViewed = this.changeBoolean(this.ifShowViewed)
        // }
        // obj.bus_id_arr = JSON.parse(sessionStorage.getItem('bus_id_arr'))
        // if (obj.bus_id_arr == null){
        //   obj.bus_id_arr=[]
        //   for (let ele of obj.bus_line){
        //     obj.bus_id_arr.push(ele.bus_id)
        //   }
        // }
        // obj.options.poi_ba_value_selection_list = data['poi_ba_value_selection_list']
        // obj.options.poi_ba_label_selection_list = data['poi_ba_label_selection_list']
        let api_url = _global.serverSrc + '/user_upload/?format=json'
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        return this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.upload_check[0].is_ok == 1) {
              //传成功了
              this.reference_id = response.data.upload_check[0].reference_id
              this.dataSaved = false
              this.openNotice()
            } else {
              //失败了
              this.openNotice2()
            }
          })
          .catch(e => {

          })




        this.dialogFormVisible = false

      },
      changeBoolean(data_poi){
        if (data_poi == false){
          data_poi = 0
        } else if (data_poi == true){
          data_poi =1
        }else{
          for (let ele in data_poi){
            if (data_poi[ele] == true){
              data_poi[ele] = 1
            }else{
              data_poi[ele] = 0
            }
          }
        }
        return data_poi
      },
      changeBooleanInverse(data_poi){
        if (data_poi == 0){
          data_poi = false
        } else if (data_poi == 1){
          data_poi = true
        }else{
          for (let ele in data_poi){
            if (data_poi[ele] == 1){
              data_poi[ele] = true
            }else{
              data_poi[ele] = false
            }
          }
        }
        return data_poi
      },
      openNotice() {
        var _self = this;
        this.$notify({
          message: _self.$t('message.The_data_is_successfully_uploaded'),
          position: 'top-left'
        });
      },
      openNotice2() {
        var _self = this;
        this.$notify({
          message: _self.$t('message.The_data_is_failed_to_upload'),
          position: 'top-left'
        });
      },
      handleUpload(file){
      
              this.clientLogoImage=file.raw
              let FR = new FileReader();
              FR.readAsDataURL(this.clientLogoImage);
              
              FR.onload=()=>{
              this.clientLogoImage=FR.result
              }
            },
      goHistory() {
        this.$router.push('./history')
      },
      delcommafy(num) {
        if (num != '' && num !=null){
          num = num.replace(/,/g, '')
        }else{
          num = 0
        }
        return Number(num)
      },
      getSummaries() {
        let sums_with_target_audience = []
        let sums_without_target_audience = []
        let sumMonth = 0
        let sumQuantity = 0
        let sumCPM = 0
        let sumImpression = 0
        let sumPrice = 0
        let avgCPM = 0
        let sumAdjustedImpression = 0
        let avgAdjustedCPM = 0
        let avgMonth = 0
        if (this.tableDataCommercial.length > 0 && this.tableDataCommercial[0].bus_id != 0) {
          this.tableDataCommercial.forEach((column, index) => {
            sumQuantity = column.bus_quantity + sumQuantity
            sumMonth = column.duration + sumMonth
            sumCPM = Number(column.CPM) + sumCPM
            sumImpression = Number(this.delcommafy(column.impression_total)) + sumImpression
            sumPrice = Number(this.delcommafy(column.price)) + sumPrice
            sumAdjustedImpression = Number(this.delcommafy(column.adjusted_impression)) + sumAdjustedImpression
          })
          avgCPM = (sumPrice / sumImpression * 1000).toFixed(2)
          avgAdjustedCPM = (sumPrice / sumAdjustedImpression * 1000).toFixed(2)
          
          avgMonth = sumMonth/this.tableDataCommercial.length
        }
        sums_with_target_audience = ['', '', '', sumQuantity, avgMonth, '', sumPrice.toLocaleString(), sumImpression.toLocaleString(),sumAdjustedImpression.toLocaleString(),
                  avgCPM,avgAdjustedCPM
                ]
        sums_without_target_audience = ['', '', '', sumQuantity, avgMonth, '', sumPrice.toLocaleString(), sumImpression.toLocaleString(),
                  avgCPM
                ]
        let tmp=[]
        tmp[0] = {
            'bus_quantity':sumQuantity,
            'duration':avgMonth,
            'price':sumPrice.toLocaleString(),
            'impression_total':sumImpression.toLocaleString(),
            'adjusted_impression':sumAdjustedImpression.toLocaleString(),
            'CPM': avgCPM,
            'adjusted_CPM': avgAdjustedCPM,
            'bus_line_number': this.tableDataCommercial.length
        }
        /*
        if(this.ifShowViewed){
          return sums_with_target_audience
        }else{
          return sums_without_target_audience
        } */
        return tmp
      },

      goHome: function() {
        this.$router.push({
          path: '/choose_city'
        });
        let lang = JSON.parse(sessionStorage.getItem("lang"));
        let user = JSON.parse(sessionStorage.getItem("User"));
        let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
        sessionStorage.clear();
        sessionStorage.setItem("lang", JSON.stringify(lang));
        sessionStorage.setItem("User", JSON.stringify(user));
        sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
      },
      goBack: function(event) {
        if (this.$route.query.back_url) {
          this.$router.push({
            path: this.$route.query.back_url, //go back to history
            query: {
              back_url: '/choose_city'
            }
          })
        }
        else {
          this.$router.push({
            path: '/map',
            query: {
              chosen_city: this.$route.query.chosen_city
            }
          })
        }
      },

      transDataOfTableData(tableData1, tableData2) {
        for (let i = 0; i < tableData1.length; i++) {
          tableData1[i].value = tableData2[i].value;
        }
      },
      fillTable() {
        this.tableDataCommercial = JSON.parse(sessionStorage.getItem('tableDataCommercial'))
        this.tableDataCommercial.forEach((item, index) => {
          this.tableDataCommercial[index].rate_card = item.rate_card.toLocaleString()
          this.tableDataCommercial[index].production_cost = item.production_cost.toLocaleString()
          this.tableDataCommercial[index].impression_total = item.impression_total.toLocaleString()
          this.tableDataCommercial[index].budget = item.budget.toLocaleString()
          this.tableDataCommercial[index].price = item.price.toLocaleString()
          this.tableDataCommercial[index].production_price = item.production_price.toLocaleString()
          this.tableDataCommercial[index].adjusted_impression = item.adjusted_impression.toLocaleString()
          this.tableDataCommercial[index].adjusted_CPM = item.adjusted_CPM.toLocaleString()
          if (this.$i18n.locale == 'cn'){
            this.tableDataCommercial[index].media_type_label = item.media_type_label_cn
          }
        })
      },
      fillData_Options() {
        this.options = JSON.parse(sessionStorage.getItem('Data_Options'))
      },
      numberBit(n){
        let b =0
        while (n>0){
          n=Math.floor(n/10)
          b=b+1
        }
        return b
      },
      fillData_Info() {
        let tmp_info = JSON.parse(sessionStorage.getItem('Data_Information'))
        Object.assign(this.information, tmp_info)
        if (tmp_info.duration !=null){
          this.information.value_duration = tmp_info.duration
        }else if (tmp_info.campaignDuration != null){
          this.information.value_duration = tmp_info.campaignDuration
          tmp_info.date = tmp_info.campaignDate
        }

        if (this.numberBit(tmp_info.date)==10){
          tmp_info.date = tmp_info.date*1000
        }
        let tmp = new Date(tmp_info.date)
        this.information.date = tmp.toISOString()
        let gender = this.information['data_audience'].value_gender
        let age = this.information['data_audience'].value_age
        let spend_power = this.information['data_audience'].value_spend_power
        let interest = this.information['data_audience'].value_interest
        let gender_options = this.options['audience_options']['gender_options']
        let age_options = this.options['audience_options']['age_options']
        let spend_power_options = this.options['audience_options']['spend_power_options']
        let interest_options = this.options['audience_options']['interest_options']
        
        this.poi_ba_value_selection_list = this.information['poi_ba_value_selection_list']
        let poi_ba_label_selection_list = this.information['poi_ba_label_selection_list']

        this.gender = this.changeDataToText(gender, gender_options)
        this.age = this.changeDataToText(age, age_options)
        this.spend_power = this.changeDataToText(spend_power, spend_power_options)
        this.interest = this.changeDataToText(interest, interest_options)
        this.poi = this.changeDataToText_poi(this.information['data_poi'])
        this.media_type = this.changeDataToText(this.information['data_media_rank'].value_media_format, this.options[
          'media_rank_options'].media_format_options)
        this.rank = this.changeDataToText(this.information['data_media_rank'].value_rank, this.options[
          'media_rank_options'].rank_options)
        if (this.rank !="") this.ifRank=true
        
        this.campaignDate =this.information.date;
        this.campaignDuration = this.information.value_duration;
        
        this.poi_ba_label_selection_list = this.changeDataToText_PoiSearch(poi_ba_label_selection_list)
      },
      fillData_map() {
        this.map = sessionStorage.getItem('Data_Map');
      },

      fillData() {
        let impression_total_arr = JSON.parse(sessionStorage.getItem('impression_total_arr'))
        let impression_average = 0
        let cpm_arr = JSON.parse(sessionStorage.getItem('cpm_arr'))
        let cpm_average = 0
        let adjusted_impression_arr = JSON.parse(sessionStorage.getItem('adjusted_impression_arr'))
        let adjusted_impression_average = 0
        let adjusted_cpm_arr = JSON.parse(sessionStorage.getItem('adjusted_cpm_arr'))
        let adjusted_cpm_average = 0
        let data = JSON.parse(sessionStorage.getItem('Data_Map'))
        let ifShowViewed

        let gender_female = []
        let gender_male = []
        let age_18_24 = []
        let age_25_34 = []
        let age_35_44 = []
        let age_45_54 = []
        let age_55_64 = []
        let spend_power_low = []
        let spend_power_medium = []
        let spend_power_high = []
        let interest_number_of_audience = []
        let interest_banking_finance = []
        let interest_beauty_healthcare = []
        let interest_cars_it = []
        let interest_lifestyle_catering = []
        let interest_online_shopping_social_media = []
        let interest_online_training_education = []
        let interest_video_entertainment = []
        let interest_travel_tourism = []
        
        let sum_gender_female = 0
        let sum_gender_male = 0
        let sum_age_18_24 = 0
        let sum_age_25_34 = 0
        let sum_age_35_44 = 0
        let sum_age_45_54 = 0
        let sum_age_55_64 = 0
        let sum_spend_power_low = 0
        let sum_spend_power_medium = 0
        let sum_spend_power_high = 0
        let sum_interest_number_of_audience = 0
        let sum_interest_banking_finance = 0
        let sum_interest_beauty_healthcare = 0
        let sum_interest_cars_it = 0
        let sum_interest_lifestyle_catering = 0
        let sum_interest_online_shopping_social_media = 0
        let sum_interest_online_training_education = 0
        let sum_interest_video_entertainment = 0
        let sum_interest_travel_tourism = 0

        let tableDataCommercial = JSON.parse(sessionStorage.getItem('tableDataCommercial'))

        for (let ele in tableDataCommercial) {
              gender_female.push(tableDataCommercial[ele]['gender_female'])
              gender_male.push(tableDataCommercial[ele]['gender_male'])
              age_18_24.push(tableDataCommercial[ele]['age_18_24'])
              age_25_34.push(tableDataCommercial[ele]['age_25_34'])
              age_35_44.push(tableDataCommercial[ele]['age_35_44'])
              age_45_54.push(tableDataCommercial[ele]['age_45_54'])
              age_55_64.push(tableDataCommercial[ele]['age_55_64'])
              spend_power_low.push(tableDataCommercial[ele]['spend_power_low'])
              spend_power_medium.push(tableDataCommercial[ele]['spend_power_medium'])
              spend_power_high.push(tableDataCommercial[ele]['spend_power_high'])
              interest_number_of_audience.push(tableDataCommercial[ele]['interest_number_of_audience'])
              interest_banking_finance.push(tableDataCommercial[ele]['interest_banking_finance'])
              interest_beauty_healthcare.push(tableDataCommercial[ele]['interest_beauty_healthcare'])
              interest_cars_it.push(tableDataCommercial[ele]['interest_cars_it'])
              interest_lifestyle_catering.push(tableDataCommercial[ele]['interest_lifestyle_catering'])
              interest_online_shopping_social_media.push(tableDataCommercial[ele]['interest_online_shopping_social_media'])
              interest_online_training_education.push(tableDataCommercial[ele]['interest_online_training_education'])
              interest_video_entertainment.push(tableDataCommercial[ele]['interest_video_entertainment'])
              interest_travel_tourism.push(tableDataCommercial[ele]['interest_travel_tourism'])

              sum_gender_female = Number(sum_gender_female) + Number(tableDataCommercial[ele]['gender_female'])
              sum_gender_male = Number(sum_gender_male) + Number(tableDataCommercial[ele]['gender_male'])
              sum_age_18_24 = Number(sum_age_18_24) + Number(tableDataCommercial[ele]['age_18_24'])
              sum_age_25_34 = Number(sum_age_25_34) + Number(tableDataCommercial[ele]['age_25_34'])
              sum_age_35_44 = Number(sum_age_35_44) + Number(tableDataCommercial[ele]['age_35_44'])
              sum_age_45_54 = Number(sum_age_45_54) + Number(tableDataCommercial[ele]['age_45_54'])
              sum_age_55_64 = Number(sum_age_55_64) + Number(tableDataCommercial[ele]['age_55_64'])
              sum_spend_power_low = Number(sum_spend_power_low) + Number(tableDataCommercial[ele]['spend_power_low'])
              sum_spend_power_medium = Number(sum_spend_power_medium) + Number(tableDataCommercial[ele]['spend_power_medium'])
              sum_spend_power_high = Number(sum_spend_power_high) + Number(tableDataCommercial[ele]['spend_power_high'])
              sum_interest_banking_finance = Number(sum_interest_banking_finance) + Number(tableDataCommercial[ele]['interest_banking_finance'])
              sum_interest_beauty_healthcare = Number(sum_interest_beauty_healthcare) + Number(tableDataCommercial[ele]['interest_beauty_healthcare'])
              sum_interest_cars_it = Number(sum_interest_cars_it) + Number(tableDataCommercial[ele]['interest_cars_it'])
              sum_interest_lifestyle_catering = Number(sum_interest_lifestyle_catering) + Number(tableDataCommercial[ele]['interest_lifestyle_catering'])
              sum_interest_online_shopping_social_media = Number(sum_interest_online_shopping_social_media) + Number(tableDataCommercial[ele]['interest_online_shopping_social_media'])
              sum_interest_online_training_education = Number(sum_interest_online_training_education) + Number(tableDataCommercial[ele]['interest_online_training_education'])
              sum_interest_video_entertainment = Number(sum_interest_video_entertainment) + Number(tableDataCommercial[ele]['interest_video_entertainment'])
              sum_interest_travel_tourism = Number(sum_interest_travel_tourism) + Number(tableDataCommercial[ele]['interest_travel_tourism'])
        }


        if (this.dataHistory != null && this.dataHistory != ""){
          impression_total_arr =[]
          cpm_arr=[]
          adjusted_impression_arr = []
          adjusted_cpm_arr = []
          ifShowViewed = this.dataHistory.ifShowViewed
          for (let ele in this.dataHistory.bus_line) {
            /* 
            bus_id_arr.push(response.data[ele]['bus_id']);
            reach_arr.push(response.data[ele]['reach']);
            frequency_arr.push(response.data[ele]['frequency']); */
            impression_total_arr.push(this.delcommafy(this.dataHistory.bus_line[ele]['impression_total']));
            /* price_arr.push(response.data[ele]['price']); */
            cpm_arr.push(Number(this.dataHistory.bus_line[ele]['CPM']));
            adjusted_impression_arr.push(this.delcommafy(this.dataHistory.bus_line[ele]['adjusted_impression']))
            adjusted_cpm_arr.push(Number(this.dataHistory.bus_line[ele]['adjusted_CPM']))

            gender_female.push(this.dataHistory.bus_line[ele]['gender_female'])
            gender_male.push(this.dataHistory.bus_line[ele]['gender_male'])
            age_18_24.push(this.dataHistory.bus_line[ele]['age_18_24'])
            age_25_34.push(this.dataHistory.bus_line[ele]['age_25_34'])
            age_35_44.push(this.dataHistory.bus_line[ele]['age_35_44'])
            age_45_54.push(this.dataHistory.bus_line[ele]['age_45_54'])
            age_55_64.push(this.dataHistory.bus_line[ele]['age_55_64'])
            spend_power_low.push(this.dataHistory.bus_line[ele]['spend_power_low'])
            spend_power_medium.push(this.dataHistory.bus_line[ele]['spend_power_medium'])
            spend_power_high.push(this.dataHistory.bus_line[ele]['spend_power_high'])
            interest_number_of_audience.push(this.dataHistory.bus_line[ele]['interest_number_of_audience'])
            interest_banking_finance.push(this.dataHistory.bus_line[ele]['interest_banking_finance'])
            interest_beauty_healthcare.push(this.dataHistory.bus_line[ele]['interest_beauty_healthcare'])
            interest_cars_it.push(this.dataHistory.bus_line[ele]['interest_cars_it'])
            interest_lifestyle_catering.push(this.dataHistory.bus_line[ele]['interest_lifestyle_catering'])
            interest_online_shopping_social_media.push(this.dataHistory.bus_line[ele]['interest_online_shopping_social_media'])
            interest_online_training_education.push(this.dataHistory.bus_line[ele]['interest_online_training_education'])
            interest_video_entertainment.push(this.dataHistory.bus_line[ele]['interest_video_entertainment'])
            interest_travel_tourism.push(this.dataHistory.bus_line[ele]['interest_travel_tourism'])
          }
          
        }else{
          //ifShowViewed = data.ifShowViewed
          ifShowViewed = JSON.parse(sessionStorage.getItem('ifShowViewed'))
        }
        
        if (impression_total_arr){
          impression_average = Math.round(this.average(impression_total_arr))
          sessionStorage.setItem('impression_total_arr_avg', JSON.stringify(impression_average));
        }else{
          impression_average = JSON.parse(sessionStorage.getItem('impression_total_arr_avg'))
        }
        if(cpm_arr){
          cpm_average = Number(this.average(cpm_arr).toFixed(2));
          sessionStorage.setItem('cpm_arr_avg', JSON.stringify(cpm_average));
        }else{
          cpm_average = JSON.parse(sessionStorage.getItem('cpm_arr_avg'))
        }
        if (adjusted_impression_arr){
          adjusted_impression_average = Math.round(this.average(adjusted_impression_arr))
          sessionStorage.setItem('adjusted_impression_arr_avg', JSON.stringify(adjusted_impression_average));
        }else{
          adjusted_impression_average = JSON.parse(sessionStorage.getItem('adjusted_impression_arr_avg'))
        }
        if(adjusted_cpm_arr){
          adjusted_cpm_average = Number(this.average(adjusted_cpm_arr).toFixed(2));
          sessionStorage.setItem('adjusted_cpm_arr_avg', JSON.stringify(adjusted_cpm_average));
        }else{
          adjusted_cpm_average = JSON.parse(sessionStorage.getItem('adjusted_cpm_arr_avg'))
        }
        let bus_id_arr = []
        // 兼容性处理：优先使用 bus_name，如果没有则回退到 bus_id
        if (this.ifSave){
          // 从历史记录加载时，检查是否有 bus_name 可用
          if (this.dataHistory.bus_line && this.dataHistory.bus_line.length > 0) {
            bus_id_arr = []
            for (let ele of this.dataHistory.bus_line) {
              bus_id_arr.push(ele.bus_name || ele.bus_id)
            }
          } else {
            bus_id_arr = this.dataHistory.bus_id_arr
          }
        }else{
          this.data = JSON.parse(sessionStorage.getItem('Data_Map'))
          this.CPM = this.data.CPM
          this.adjusted_CPM = this.data.adjusted_CPM
          bus_id_arr = JSON.parse(sessionStorage.getItem('bus_id_arr'))
          // 如果 sessionStorage 中没有或格式不对，尝试从 selectedBusLine 获取
          if (!bus_id_arr || bus_id_arr.length === 0) {
            if (this.selectedBusLine && this.selectedBusLine.length > 0) {
              bus_id_arr = []
              for (let ele of this.selectedBusLine) {
                bus_id_arr.push(ele.bus_name || ele.bus_id)
              }
            }
          }
        }

        if (ifShowViewed){
          this.impression_datasets = [{
            label: this.$t('message.Viewed_Impression'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: impression_total_arr
          },
          {
            label: this.$t('message.Viewed_Impression(Audience)'),
            backgroundColor: '#80DEEA',
            borderColor: '#00ACC1',
            borderWidth: 1,
            hoverBackgroundColor: '#00ACC1',
            barPercentage: 0.8,
            data: adjusted_impression_arr
          }]

          this.impression_annotations = [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: impression_average,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + parseInt(impression_average).toLocaleString(),
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            },
            {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: adjusted_impression_average,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + parseInt(adjusted_impression_average).toLocaleString(),
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            }]
          
          this.cpm_datasets = [{
            label: this.$t('message.CPM'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: cpm_arr
          },
          { 
            label: this.$t('message.CPM_Target_Audience_Based'),
            backgroundColor: '#80DEEA',
            borderColor: '#00ACC1',
            borderWidth: 1,
            hoverBackgroundColor: '#00ACC1',
            barPercentage: 0.8,
            data: adjusted_cpm_arr
          }]
          this.cpm_annotations = [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.CPM,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + this.CPM,
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            },
              {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.adjusted_CPM,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + this.adjusted_CPM,
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              }
            }]
        }else{
          this.impression_datasets = [{
            label: this.$t('message.Viewed_Impression'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: impression_total_arr
          }]
          this.impression_annotations = [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: impression_average,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + (impression_average).toLocaleString(),
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              }
            }]
          
          this.cpm_datasets = [{
            label: this.$t('message.CPM'),
            backgroundColor: '#039BE599',
            borderColor: '#039BE5',
            borderWidth: 1,
            hoverBackgroundColor: '#039BE5',
            barPercentage: 0.8,
            data: cpm_arr
          }]
          this.cpm_annotations = [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: this.CPM,
              borderColor: '#3949AB4D',
              borderWidth: 2,
              label: {
                content: this.$t('message.Average') + this.CPM,
                enabled: true,
                fontSize: 16,
                position: "right",
                backgroundColor: 'rgba(0,0,0,0.8)',
              },
            }]
        }

        this.datacollection_impression_total = {
          labels: bus_id_arr,
          datasets: this.impression_datasets
        };
        this.datacollection_cpm = {
          labels: bus_id_arr,
          datasets: this.cpm_datasets
        };
        this.chart_options_impression_total = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Viewed_Impression_chart'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          legend: {
            display: true,
          },
          gridLines: {
            offsetGridLines: false
          },
          scaleLabel:"<%=value%>",

          scales: {
            yAxes: [{
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                precision: 10,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          },
          annotation: {
            annotations: this.impression_annotations
          }
        };
        this.chart_options_cpm = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.CPM_chart'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          legend: {
            display: true,
          },
          gridLines: {
            offsetGridLines: false
          },

          scales: {
            yAxes: [{
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15
              }
            }],
            xAxes: [{
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          },
          annotation: {
            annotations: this.cpm_annotations
          }
        };

        this.datacollection_gender = {
          labels: bus_id_arr,
          datasets: [{
            label: this.$t('message.gender_female'),
            backgroundColor: '#F48FB1',
            //borderColor: '#039BE5',
            //borderWidth: 1,
            //hoverBackgroundColor: '#039BE5',
            //barPercentage: 0.8,
            data: gender_female
          },
          { 
            label: this.$t('message.gender_male'),
            backgroundColor: '#42A5F5',
            data:gender_male
          }]
        }
        this.datacollection_age = {
          labels: bus_id_arr,
          datasets: [{
            label: this.$t('message.age_18_24'),
            backgroundColor: '#B2DFDB',
            data: age_18_24
          },
          { 
            label: this.$t('message.age_25_34'),
            backgroundColor: '#4DB6AC',
            data:age_25_34
          },
          {
            label: this.$t('message.age_35_44'),
            backgroundColor: '#009688',
            data: age_35_44
          },
          { 
            label: this.$t('message.age_45_54'),
            backgroundColor: '#00796B',
            data:age_45_54
          },
          { 
            label: this.$t('message.age_55_64'),
            backgroundColor: '#00695C',
            data:age_55_64
          }
          ]
        }
        this.datacollection_spend_power = {
           labels: bus_id_arr,
          datasets: [{
            label: this.$t('message.spend_power_low'),
            backgroundColor: '#FFB74D',
            data: spend_power_low
          },
          { 
            label: this.$t('message.spend_power_medium'),
            backgroundColor: '#FF9800',
            data:spend_power_medium
          },
          {
            label: this.$t('message.spend_power_high'),
            backgroundColor: '#F57C00',
            data: spend_power_high
          }]
        }
        this.datacollection_interest = {
          labels: bus_id_arr,
          datasets: [{
            label: this.$t('message.interest_banking_finance'),
            backgroundColor: '#3949AB',
            data: interest_banking_finance
          },
          { 
            label: this.$t('message.interest_beauty_healthcare'),
            backgroundColor: '#1E88E5',
            data:interest_beauty_healthcare
          },
          {
            label: this.$t('message.interest_cars_it'),
            backgroundColor: '#00ACC1',
            data: interest_cars_it
          },
          { 
            label: this.$t('message.interest_lifestyle_catering'),
            backgroundColor: '#00897B',
            data:interest_lifestyle_catering
          },
          { 
            label: this.$t('message.interest_online_shopping_social_media'),
            backgroundColor: '#7CB342',
            data:interest_online_shopping_social_media
          },
          { 
            label: this.$t('message.interest_online_training_education'),
            backgroundColor: '#C0CA33',
            data:interest_online_training_education
          },
          { 
            label: this.$t('message.interest_video_entertainment'),
            backgroundColor: '#FFB300',
            data:interest_video_entertainment
          },
          { 
            label: this.$t('message.interest_travel_tourism'),
            backgroundColor: '#F4511E',
            data:interest_travel_tourism
          }]
        }
        this.chart_options_gender = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Detailed_distribution_gender'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          scales: 
          {
            yAxes: [{
              stacked: true,
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          }
        }
        this.chart_options_age = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Detailed_distribution_age'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          scales: 
          {
            yAxes: [{
              stacked: true,
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          }
        }
        this.chart_options_spend_power = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Detailed_distribution_spend_power'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          scales: 
          {
            yAxes: [{
              stacked: true,
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          }
        }
        this.chart_options_interest = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Detailed_distribution_interest'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },
          scales: 
          {
            yAxes: [{
              stacked: true,
              ticks: {
                maxTicksLimit: 8,
                beginAtZero: true,
                fontSize: 15,
                callback: function(value, index, values) {
                        return value/1000 + 'k';
                    }
              }
            }],
            xAxes: [{
              stacked: true,
              ticks: {
                display: true,
                fontSize: 15,
                fontStyle: 'bold',
              },
              gridLines: {
                display: false
              }
            }]
          }
        }

        this.datacollection_package_gender = {
          labels: [this.$t('message.gender_female'),this.$t('message.gender_male')],
          datasets:[{
            backgroundColor:['#F48FB1','#42A5F5'],
            data: [sum_gender_female,sum_gender_male]
          }]
        }
        this.datacollection_package_age = {
          labels: [this.$t('message.age_18_24'),this.$t('message.age_25_34'),this.$t('message.age_35_44'),this.$t('message.age_45_54'),this.$t('message.age_55_64')],
          datasets:[{
            backgroundColor:['#B2DFDB','#4DB6AC','#009688','#00796B','#00695C'],
            data: [sum_age_18_24,sum_age_25_34,sum_age_35_44,sum_age_45_54,sum_age_55_64]
          }]
        }
        this.datacollection_package_spend_power = {
          labels: [this.$t('message.spend_power_low'),this.$t('message.spend_power_medium'),this.$t('message.spend_power_high')],
          datasets:[{
            backgroundColor:['#FFB74D','#FF9800','#F57C00'],
            data: [sum_spend_power_low,sum_spend_power_medium,sum_spend_power_high]
          }]
        }
        this.datacollection_package_interest = {
          labels: [this.$t('message.interest_banking_finance'),this.$t('message.interest_beauty_healthcare'),this.$t('message.interest_cars_it'),this.$t('message.interest_lifestyle_catering'),this.$t('message.interest_online_shopping_social_media'),this.$t('message.interest_online_training_education'),this.$t('message.interest_video_entertainment'),this.$t('message.interest_travel_tourism')],
          datasets:[{
            backgroundColor:['#3949AB','#1E88E5','#00ACC1','#00897B','#7CB342', '#C0CA33','#FFB300','#F4511E'],
            data: [sum_interest_banking_finance,sum_interest_beauty_healthcare,sum_interest_cars_it,sum_interest_lifestyle_catering,sum_interest_online_shopping_social_media,sum_interest_online_training_education,sum_interest_video_entertainment,sum_interest_travel_tourism]
          }]
        }
        this.chart_options_package_gender = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Overall_distribution_gender'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },

        }
        this.chart_options_package_age = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Overall_distribution_age'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },

        }
        this.chart_options_package_spend_power = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Overall_distribution_spend_power'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },

        }
        this.chart_options_package_interest = {
          maintainAspectRatio: false,
          title: {
            display: true,
            text: this.$t('message.Overall_distribution_interest'),
            fontSize: 23,
            padding: 40,
            lineHeight: 0.2
          },

        }


      },

      changeDataToText_poi(poi) {
        let str = "";
        if (poi.checked_business == true) {
          str = str + this.$t('message.BUSINESS') + ' ';
        }
        if (poi.checked_entertainment == true) {
          str = str + this.$t('message.ENTERTAINEMENT') + ' ';
        }
        if (poi.checked_living == true) {
          str = str + this.$t('message.LIVING') + ' ';
        }
        if (poi.checked_trip == true) {
          str = str + this.$t('message.TRIP');
        }
        return str;
      },

      changeDataToText(data, options) {
        let obj = "";
        if (this.$i18n.locale == 'en'){
          if (typeof(data) == "number") {
            for (let i = 0; i < options.length; i++) {
              if (Number(options[i].value) == data) {
                obj = obj + options[i].label;
              }
            }
          } else if (typeof(data) == "object") {
            if (data.length > 1) {
              data = data.sort();
            }
          
            for (let d in data) {
              for (let op in options) {
                if (Number(data[d]) == Number(options[op].value)) {
                  obj = obj + String(options[op].label) + ' ';
                }
              }
            }
          }
        }else if (this.$i18n.locale == 'cn'){
          if (typeof(data) == "number") {
            for (let i = 0; i < options.length; i++) {
              if (Number(options[i].value) == data) {
                obj = obj + options[i].label_cn;
              }
            }
          } else if (typeof(data) == "object") {
            if (data.length > 1) {
              data = data.sort();
            }
          
            for (let d in data) {
              for (let op in options) {
                if (Number(data[d]) == Number(options[op].value)) {
                  obj = obj + String(options[op].label_cn) + ' ';
                }
              }
            }
          }
        }
        
        
        return obj;
      },
      changeDataToText_PoiSearch(poi_ba_label_selection_list){
          let poi_ba_label_selection_list_text = ''
          for (let index in poi_ba_label_selection_list){
            poi_ba_label_selection_list_text = poi_ba_label_selection_list_text + poi_ba_label_selection_list[index] + ' '
          }
          return poi_ba_label_selection_list_text
      },
      getRandomInt() {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      average(numbers) {
        var total = 0,
          i;
        for (i = 0; i < numbers.length; i += 1) {
          total += numbers[i];
        }
        return total / numbers.length;
      },
      modifyInfo() {
        this.$router.push({
          path: '/information',
          query: {
            chosen_city: this.chosen_city
          }
        });
      },
      leftRight({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex === 0) {
          return 'font-weight:700';
        } else if (columnIndex === 1) {
          return 'font-size:25px';
        }
      },

      async exportTypeSelector(){
        switch(this.exportType){
          case '':
            this.$message(this.$t('message.Please_select_file_type'))
            break;
          case 'PDF':
          
            // if (this.onSubmit()){
              // wait saveDate() finsh and return reference_id
              //await this.saveData()
              await this.messageSaveData()
              // wait getReportInfo() finsh and return created_by and bu_city
              await this.getReportInfo()
              this.getPdf(this.form.name,this.clientLogoImage,this.chosen_city,this.campaignDate,this.duration,this.tableData,this.package_cpm,this.package_price,this.gender,this.age,this.spend_power,this.interest,this.poi,this.media_type,this.selectedBusLine,this.reference_id,this.createdBy,this.team,this.ifShowViewed,this.package_cpm_cluster,this.poi_ba_label_selection_list,this.totalNearbyBusNumber)
            //}
            break;
          case 'Excel':
          
            if (this.onSubmit()){
              this.getExcel()
            }
            break;
          case 'Hub Template':
          
            if (this.onSubmit()){
              this.getHubTemplateExcel()
            }
            break;
        }
      },


      getReportInfo() {
        let api_url = _global.serverSrc + '/user_history/?format=json';
        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        return this.$axios.post(api_url,obj)
          .then(response => {
            if (response != null) {
              for (let ele of response.data.user_history) {
                if (ele.reference_id == this.reference_id){
                  this.createdBy = ele.created_by
                  this.team = ele.bu_city
                  break
                }
                
              }
            }
          })
          .catch(e => {
          })
      },

      showBusLine(){
        this.$refs.mapf.clearMap();
        for (let ele in this.selectedBusLine) {
          this.$refs.mapf.lineSearch(this.selectedBusLine[ele].bus_name ? this.selectedBusLine[ele].bus_name : this.selectedBusLine[ele].bus_id.replace("line ", "") + "路",this.chosen_city);
        }
        this.getSelectedPoiLocation(this.poi_ba_value_selection_list,this.$refs.mapf)
      },

      changeDetailInfoView(){      
        if (this.dataHistory != null && this.dataHistory != ""){
          this.dataHistory.ifShowViewed = this.ifShowViewed
          sessionStorage.setItem('Data_History', JSON.stringify(this.dataHistory));
        }else{
          sessionStorage.setItem('ifShowViewed', JSON.stringify(this.ifShowViewed));
        }
        this.$router.go(0)
      },

      getSelectedPoiLocation(poi_list,mapf) {
        let api_url = _global.serverSrc + '/selected_poi_location/?format=json&chosen_city=' + this.chosen_city;
        let obj = {
          'email': JSON.parse(sessionStorage.getItem('User')),
          'poi_list': poi_list
        }
        this.$axios.post(api_url, obj)
            .then(response => {
              mapf.drawPoi(response.data.selected_poi_location)
            })
            .catch(e => {
          })
      }
    },
    watch: {
      localLang() {
        //this.fillData_Info();
        this.fillPackageData()
      }
    },
    components: {
      head_page,
      head_menu,
      BarChart,
      DoughnutChart,
      mapf
    },
  }
</script>

<style scoped>
  
  .level2_div2 {
    /* z-index:50; */
    /* background-color: #EFEFEF; */
    position: relative;
    background-color: white;
    /* height:300px;
			width:00px; */
    margin: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    /* border-style:ridge; */
    border-color: '#039BE5';
    border-width: 5px;
    margin-bottom: 40px;
    /* background-color: #E0E0E066; */
  }

  #inside_map {
    padding-top:50px;
    padding-bottom: 20px;
  }
  
  .info-list-style {
    background-color: white;
    background-clip: content-box;
    border-radius: 0;
  }

  .table-style{
    background-color: #EFEFEF;
    padding: 20px;
  }
</style>
